module.exports = __webpack_public_path__ + "static/media/src-design01.6ebaf743.png";